module.exports = __webpack_public_path__ + "static/media/captions_Irish_Wharfdale.6cbb6530.vtt";


//////////////////
// WEBPACK FOOTER
// ./src/subtitles/captions_Irish_Wharfdale.vtt
// module id = 121
// module chunks = 0